import React from "react";
import { T, useT } from "@transifex/react";
import { Accordion } from "storybook/components/accordion";
import { Checkbox } from "storybook/components/checkbox";
import { Typography } from "storybook/components/typography";
import { AccordionDetails, AccordionContents, ContentWrapper } from "../styles";

type Props = {
  content: React.ReactNode;
};

export const LungCtAccordion = ({ content }: Props) => {
  const t = useT();

  const hasContent = Boolean(content);

  return (
    <Accordion
      theme="default"
      ariaLabel={t("Low Dose Lung CT")}
      initialExpanded={hasContent}
      title={
        <AccordionDetails>
          <Checkbox
            size="medium"
            hideDirty={true}
            theme="patient-facing"
            label={t("Low Dose Lung CT")}
            name="screenings.lungCT"
          />
          {hasContent && (
            <Typography
              theme="default"
              variant="body1"
              component="h2"
              color="black"
            >
              <T _str="Key steps for getting a Low Dose Lung CT" />
            </Typography>
          )}
          <div></div>
        </AccordionDetails>
      }
    >
      {hasContent ? (
        <AccordionContents>
          <ContentWrapper>
            <div role="article" className="notranslate">
              {content}
            </div>
          </ContentWrapper>
        </AccordionContents>
      ) : null}
    </Accordion>
  );
};
